import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const EditEducationRecordModal = ({ isOpen, onClose, onSubmit, record }) => {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [type, setType] = useState('');
  const [content, setContent] = useState('');
  const [instructor, setInstructor] = useState('');
  const [examiner, setExaminer] = useState('');
  const [trainingDuration, setTrainingDuration] = useState('');
  const [examScore, setExamScore] = useState('');
  const [examResult, setExamResult] = useState('合格');
  const [companyNotes, setCompanyNotes] = useState('');
  const [departmentNotes, setDepartmentNotes] = useState('');
  const [teamNotes, setTeamNotes] = useState('');
  // 删除未使用变量 activeNoteTab 和 addToast，清理 ESLint 警告

  useEffect(() => {
    if (record) {
      setTitle(record.title || '');
      setDate(record.date || '');
      setType(record.education_type || '');
      setContent(record.content || '');
      setInstructor(record.instructor || '');
      setExaminer(record.examiner || '');
      setTrainingDuration(record.training_duration || '');
      setExamScore(record.exam_score || '');
      setExamResult(record.exam_result || '合格');
      setCompanyNotes(record.company_notes || '');
      setDepartmentNotes(record.department_notes || '');
      setTeamNotes(record.team_notes || '');
      // setActiveNoteTab('company');
    }
  }, [record]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const recordData = {
      title, date, education_type: type, content, instructor, examiner, training_duration: trainingDuration, exam_score: examScore, exam_result: examResult, company_notes: companyNotes, department_notes: departmentNotes, team_notes: teamNotes
    };
    onSubmit(recordData);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="编辑教育记录">
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 12 }}>
          <label>标题</label>
          <input value={title} onChange={e => setTitle(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>日期</label>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>类型</label>
          <input value={type} onChange={e => setType(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>内容</label>
          <textarea value={content} onChange={e => setContent(e.target.value)} rows={4} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>讲师</label>
          <input value={instructor} onChange={e => setInstructor(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>考核人</label>
          <input value={examiner} onChange={e => setExaminer(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>培训时长</label>
          <input value={trainingDuration} onChange={e => setTrainingDuration(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>考试成绩</label>
          <input value={examScore} onChange={e => setExamScore(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>考试结论</label>
          <input value={examResult} onChange={e => setExamResult(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>公司备注</label>
          <input value={companyNotes} onChange={e => setCompanyNotes(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>部门备注</label>
          <input value={departmentNotes} onChange={e => setDepartmentNotes(e.target.value)} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label>班组备注</label>
          <input value={teamNotes} onChange={e => setTeamNotes(e.target.value)} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button type="button" onClick={onClose}>取消</button>
          <button type="submit">保存</button>
        </div>
      </form>
    </Modal>
  );
};

export default EditEducationRecordModal;
